import { createContext, useContext } from 'react'
import { Event } from '@wellesley/openapi'

export type EventsContextType = {
  openEventDialog: (args?: { event: Event | null; copyAsNew?: boolean }) => void
  openCancelDialog: (args: { event: Event }) => void
}

export const EventsContext = createContext<EventsContextType>(
  {} as EventsContextType,
)

export const useEventsContext = () => {
  const context = useContext(EventsContext)
  if (!context) {
    throw new Error(
      'useEventsContext must be used within an EventsContextProvider',
    )
  }
  return context
}
